export const navigation = {
	header: {
		title: "Todas as categorias",
		searchTooltip: "Buscar categorias",
		addCategoryTooltip: "Adicionar categoria",
		showZeroProductCategoriesTooltip: "Mostrar categorias sem produtos",
		hideZeroProductCategoriesTooltip: "Ocultar categorias sem produtos",
		showEmptyCategories: "Mostrar categorias sem produtos",
		hideEmptyCategories: "Ocultar categorias sem produtos",
		show: "Mostrar",
		hide: "Ocultar",
	},
	search: {
		placeholder: "Buscar categoria",
		closeTooltip: "Fechar busca",
	},
	subcategories: {
		levelPrefix: "Nível",
	},
	priorityLabel: "Nível",
	categoryDisabledTooltip: "Não é possível adicionar produtos a essa categoria",
	loadingCategories: "Carregando categorias",
	emptyState: {
		noSearchResults: {
			title: "Nenhuma categoria encontrada",
			message: "Não encontramos categorias que correspondam à sua busca por",
		},
		noCategories: {
			title: "Nenhuma categoria encontrada",
			message: "Não existem categorias com produtos vinculados",
		},
		noCategoriesWithFilters: {
			title: "Nenhuma categoria encontrada",
			message:
				"Não existem categorias que correspondam aos filtros aplicados",
		},
		clearSearchButton: "Limpar busca",
		clearFiltersButton: "Limpar filtros",
		createCategoryButton: "Criar categoria",
		showHiddenCategoriesButton: "Mostrar categorias",
	},
};
